import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonBar, useTheme } from "@tvg/design-system";
import { switchTimeframe } from "@tvg/sh-lib-my-bets/utils/service";
import { sendTimeframeSelectionGtmEvent } from "@tvg/sh-lib-my-bets/utils/gtm";
import {
  getSelectedSettledTab,
  getSelectedTab,
  getTodaySettledCounter,
  getTotalActiveBets
} from "@tvg/sh-lib-my-bets/redux/selectors";
import { SettledTabEnum } from "@tvg/sh-lib-my-bets/utils/types";
import { getTimeFramesTabs } from "../utils";
import { Filters } from "./styled-components";

const MyBetsDateFilter = () => {
  const dispatch = useDispatch();
  const { space, colors } = useTheme();
  const selectedSettledTab = useSelector(getSelectedSettledTab);
  const selectedTab = useSelector(getSelectedTab);
  const totalActiveBets = useSelector(getTotalActiveBets);
  const settledBetsCounter = useSelector(getTodaySettledCounter);
  const timeFramesTabs = getTimeFramesTabs();

  return (
    <Filters data-qa-label="myBets-filters" space={space} colors={colors}>
      <ButtonBar.Group
        qaLabel="ButtonBar"
        selectedValue={selectedSettledTab}
        showScrollBars={false}
        onChange={(tab) => {
          switchTimeframe(tab as SettledTabEnum, dispatch);
          sendTimeframeSelectionGtmEvent(
            tab as SettledTabEnum,
            selectedTab,
            totalActiveBets,
            settledBetsCounter
          );
        }}
        paddingAround={true}
      >
        {timeFramesTabs.map((tab) => (
          <ButtonBar
            qaLabel={tab.qaLabel}
            value={tab.value}
            borderRadius={50}
            focusOnSelected
          >
            {tab.label}
          </ButtonBar>
        ))}
      </ButtonBar.Group>
    </Filters>
  );
};

export default MyBetsDateFilter;
